export default __webpack_public_path__ + "static/media/referFriendInfoTam.a511fb4a.svg";